import React, { useEffect, useState } from "react";
import { Document, Page, pdfjs, View, Text } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import "./pdf.css";
import { FiChevronsRight, FiChevronsLeft } from "react-icons/fi";
import { ControlButtons } from "../controlButtons";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export const PdfViewer = ({ url, handleExpand, modal }) => {
  const [numPages, setNumPages] = useState();
  const [pageNumber, setPageNumber] = useState(0);
  const [showPages, setShowPages] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    console.log({ data });
  }, [data]);

  useEffect(() => {
    let isMounted = true;
    const fetchPdfData = async (url) => {
      const response = await fetch(url);
      const data = await response.blob();
      const urlObject = URL.createObjectURL(data);
      console.log({ urlObject });
      setData(urlObject);
    };
    fetchPdfData(url);

    return () => {
      isMounted = false;
    };
  }, []);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setShowPages(true);
  }
  const handlePrevPage = () => {
    if (pageNumber > 1) {
      setPageNumber(pageNumber - 1);
    }
  };
  const handleNextPage = () => {
    if (pageNumber < numPages) {
      setPageNumber(pageNumber + 1);
    }
  };

  return (
    <div className="pdf-viewer">
      {data && data.slice(0, 4) === "blob" && (
        <Document
          file={data}
          onLoadSuccess={onDocumentLoadSuccess}
          onError={console.error}
          loading={<div className="loading-cont">Loading...</div>}
        >
          <Page
            pageNumber={pageNumber+1}
            className="pdf-page"
            devicePixelRatio={2}
          />
        </Document>
      )}
      {/* {showPages && (
        <div className="pdf-page-controls">
          <button
            onClick={handlePrevPage}
            color="info"
            variant="outline"
            disabled={pageNumber === 1}
          >
            <FiChevronsLeft />
          </button>
          <p className="m-0">
            {pageNumber} of {numPages}
          </p>
          <button
            onClick={handleNextPage}
            color="info"
            variant="outline"
            disabled={pageNumber === numPages}
          >
            <FiChevronsRight />
          </button>
        </div>
      )} */}
      {numPages > 1 && (
        <ControlButtons
          page={pageNumber}
          data={{length: numPages}}
          handleExpand={handleExpand}
          setPage={setPageNumber}
          modal={modal}
        />
      )}
    </div>
  );
};
